import React from 'react'
import { useSnapshot } from 'valtio'
import { state } from '../../context/store'
import { capitalizeFirstLetter, getOrdinal } from '../../utilities'
import { Text, Column, SummaryLine, Hr, Columns } from '../Blocks/index'

const OrderSummary = () => {
  const snap = useSnapshot(state.current)

  const RaceNumberSummary = () => {

    return (
      <Column gap="0" justify="start">
        <Text size="15px">Race Number</Text>
        <SummaryLine title="Number" data={snap.choices.raceNumber.selected.number} />
        <SummaryLine title=" Color" data={snap.choices.raceNumber.selected.name} />
        <SummaryLine title="Outline" data={snap.choices.raceNumber.selected.outlineName} />
        <Hr />
      </Column>
    )
  }

  const RibChoices = () => {

    const input = snap.choices.ribs.selected.mode
    let message = ""
    switch (input) {
      case "no":
        message = 'None Needed'
        break
      case "single":
        message = `${capitalizeFirstLetter(snap.choices.ribs.selected.rib[0].name)} Ribs`
        break
    }

    return (
      <SummaryLine title="Ribs" data={message} />
    )
  }



  const MultiRibChoices = () => {

    return (
      <Column gap="0">
        <Text size="15px">Multiple Rib Colors</Text>

        {snap.choices.ribs.selected.rib.map((rib, index) => {
          if (index < snap.initialChoices.ribLimit) {
            {/* console.log(rib, index) */ }
            const name = "selectedMultiRib" + (index + 1)
            const title = (index + 1) + getOrdinal(index + 1) + " Rib"
            return (
              <SummaryLine key={index + "rib-option"} title={title} data={capitalizeFirstLetter(rib.name)} />

            )
          }
        })}
        <Hr />
      </Column>

    )
  }

  const Sealant = () => {

    let message = ""
    switch (snap.choices.sealant.selected.mode) {
      case "no":
        message = 'Not Needed'
        break
      case "sealant":
        message = "With waterproof sealant +$23"
        break
    }

    return (
      <Column gap="0">

        <Text mobileText="Waterproof" size="15px">Waterproof Sealant</Text>


        <SummaryLine title="Sealant" data={message} />
        <Hr />

      </Column>

    )
  }

  return (

    <Columns fr="1fr 1fr">


      <Column gap="2px">

        <Text size="15px">Model Info</Text>
        <SummaryLine title="Make" data={capitalizeFirstLetter(snap.initialChoices.make.name)} />
        <SummaryLine title="Model" data={capitalizeFirstLetter(snap.initialChoices.model.name)} />
        <SummaryLine title="Year" data={capitalizeFirstLetter(snap.initialChoices.year.name)} />
        {/* <SummaryLine title="Code" data={(snap.initialChoices.inhouseCode)} /> */}
        <Hr />

      </Column>

      <Column gap="2px" justify="start">

        <Text size="15px">Color Choices</Text>

        <SummaryLine title="Side Color" data={capitalizeFirstLetter(snap.choices.sidePanels.selected.name)} />
        <SummaryLine title="Top Color" data={capitalizeFirstLetter(snap.choices.topPanel.selected.name)} />
        <Hr />

      </Column>



      {snap.choices.ribs.selected.mode === "single" ? (

        <Column gap="2px" justify="start">

          <Text size="15px">Ribs</Text>


          <RibChoices />
          <Hr />
        </Column>

      ) : snap.choices.ribs.selected.mode === "multiple" ? <MultiRibChoices /> : null}


      {snap.choices.superBadge?.selected?.mode === "badge" ? (

        <Column gap="2px" justify="start">

          <Text size="15px">Badge</Text>

          <SummaryLine title="Badge Type" data={`With ${capitalizeFirstLetter(snap.choices.superBadge.selected.subMode)}`} />
          {snap.choices.superBadge.selected.subMode === "number" && <SummaryLine title="Badge Number" data={capitalizeFirstLetter(snap.choices.superBadge.selected.number)} />}
          {snap.choices.superBadge.selected.subMode === "name" && <SummaryLine title="Rider Name" data={capitalizeFirstLetter(snap.choices.superBadge.selected.riderName)} />}
          {snap.choices.superBadge.selected.subMode === "name" && <SummaryLine title="Font" data={capitalizeFirstLetter(snap.choices.superBadge.selected.nameFont)} />}
          {snap.choices.superBadge.selected.subMode === "number" && <SummaryLine title="Font" data={capitalizeFirstLetter(snap.choices.superBadge.selected.numFont)} />}
          {snap.choices.superBadge.selected.subMode === "name" || snap.choices.superBadge.selected.subMode === "number" ? <SummaryLine title="Font Color" data={capitalizeFirstLetter(snap.choices.superBadge.selected.name)} /> : null}
          {snap.choices.superBadge.selected.subMode === "image" && <SummaryLine title="Logo" data={capitalizeFirstLetter("Uploaded Image")} />}
          {snap.choices.superBadge.selected.subMode === "image" && <SummaryLine title="Logo Name" data={capitalizeFirstLetter(snap.uploadedFile.name)} />}

          <Hr />

        </Column>

      ) : null}

      {snap.package === "superlite" ? null : (
        <>

          <Text size="15px">Logos</Text>
          <SummaryLine title="Top Logo" data={capitalizeFirstLetter(snap.choices.topLogo.selected.mode)} />


          <Column gap="2px" justify="start">

            <SummaryLine title="Side Logos" data={snap.choices.sideLogos.selected === "enjoy" ? "enjoyMfg" : capitalizeFirstLetter(snap.choices.sideLogos.selected.name)} />
            <Hr />

          </Column>
        </>)}


      {snap.choices.raceNumber.selected.mode !== "none" ? <RaceNumberSummary /> : null}

      <Sealant />

    </Columns>

  )
}

export default OrderSummary

